module.exports = __webpack_public_path__ + "img/delete-bin.4793ebd8.svg";